// removed by extract-text-webpack-plugin
module.exports = {"personal-details":"personal-details__785b9","fund-item":"fund-item__8UElu","fund-img":"fund-img__2-giR","fund-item-collapse":"fund-item-collapse__1pRBH","edit-btn":"edit-btn__3OKho","hide":"hide__1Dqqu","divider-1":"divider-1__1QO_L","kyc-img":"kyc-img__1dux2","ml90":"ml90__2Fs-2","kyc-heading":"kyc-heading__3yyqN","kyc-content":"kyc-content__1XYh5","bank-sipdate-wrapper":"bank-sipdate-wrapper__1ObBA","sipdate-wrapper":"sipdate-wrapper__24x3n","selected":"selected__2nJrk","bank-msg-warning":"bank-msg-warning__2-AwR"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/paymentFundsSummary.scss
// module id = 46
// module chunks = 68